import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

export default class extends Controller {
  static values = { url: String, sortParamName: { type: String, default: "recommended_post_ids" } }

  connect() {
    this.sortable = Sortable.create(this.element, {
      animation: 150,
      handle: "[data-sortable-handle]",
      onEnd: () => this.updateOrder()
    })
  }

  disconnect() {
    this.sortable?.destroy()
  }

  async updateOrder() {
    if (!this.urlValue) return

    const ids = Array.from(this.element.children)
      .map(row => parseInt(row.dataset.sortableId))
      .filter(id => Number.isInteger(id))
    if (ids.length === 0) return

    const csrfToken = document.querySelector("meta[name='csrf-token']")?.content

    await fetch(this.urlValue, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": csrfToken
      },
      body: JSON.stringify({ [this.sortParamNameValue]: ids })
    })
  }
}
